/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCalendar: {
  name: 'calendar';
  data: string;
} = {
  name: 'calendar',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 .5a.5.5 0 0 1 .5.5v1.5H13A1.5 1.5 0 0 1 14.5 4v10a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 14V4A1.5 1.5 0 0 1 3 2.5h1.5V1a.5.5 0 0 1 1 0v1.5h5V1a.5.5 0 0 1 .5-.5Zm-6.5 3V4a.5.5 0 0 0 1 0v-.5h5V4a.5.5 0 0 0 1 0v-.5H13a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h1.5Zm0 3.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5Z" fill="currentColor"/></svg>`,
};
